import { ListItemIcon, useTheme } from '@mui/material';

import PlusIcon from '~icons/knowz-iconify/plus';
import UsersRoundedIcon from '~icons/knowz-iconify/users-rounded';

import { Text } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';
import StyledStack from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover/sections/content/tabs/tab-panels/sections/components/create-new-workspace-buttton/styles';
import { StyledChip } from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover/sections/content/tabs/tab-panels/sections/owned-workspaces/styles';
import {
  StyledAvatar,
  StyledCenteredStackContent,
} from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover/sections/content/tabs/tab-panels/styles';

export default function CreateNewWorkspaceButton() {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <StyledStack direction="row">
      <ListItemIcon>
        <StyledAvatar>
          <PlusIcon />
        </StyledAvatar>
      </ListItemIcon>
      <StyledStack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Text variant="textSm">
          {t('page.workspace.createButton.dropdown', 'Create New')}
        </Text>
        <StyledChip
          size="small"
          label={
            <StyledCenteredStackContent gap={1}>
              <UsersRoundedIcon
                style={{ color: theme.palette.utility.gray700 }}
              />
              <Text
                variant="textXs"
                sx={{ color: 'utility.gray.800' }}
              >
                0
              </Text>
            </StyledCenteredStackContent>
          }
        />
      </StyledStack>
    </StyledStack>
  );
}
